import React, { FC, ReactNode } from 'react';

interface ModalBaseProps {
    children: ReactNode;
    close: () => void;
    title: string;
}

const ModalBase: FC<ModalBaseProps> = ({ children, close, title }) => {
    return (
        <div className="dcr-modal-back" onClick={e => { if (e.target === e.currentTarget) close(); }}>
            <div className="dcr-modal">
                <button className="dcr-modal-close" onClick={close} aria-label="Close">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                </button>
                <h2>{title}</h2>
                {children}
            </div>
        </div>
    );
};

export default ModalBase;
